import Sidebar from "components/Sidebar/Sidebar"
import React, { Component } from "react"
import { Link } from "react-router-dom"
import shop from "shop/shop"
import Price from "../Price/Price"
import "./CartMini.scss"
import app from "app.controller"
import { Icon, Button } from "semantic-ui-react"

export default class CartMini extends Component {
  constructor( props ) {
    super()
    this.state = {
      products: productEntries( { remove: props.disableRemove ? false : this.remove } )
    }
  }

  remove = ( product ) => {
    console.log( `removing`, product )
    shop.cart.remove( product )
  }

  componentDidMount() {
    this.cartListener = shop.cart.hooks.changed.add( this.updateCart )
    shop.cart.hydrate()
  }

  updateCart = () => {
    let products = productEntries( { remove: this.props.disableRemove ? false : this.remove } )
    this.setState( { products } )
  }

  componentWillUnmount() {
    shop.cart.hooks.changed.remove( this.updateCart )
  }

  render() {
    let { products} = this.state
    let test = getProducts()
    let {sum, loading} = shop.cart

    return (
      <div className="cart cart-mini">

        <div className="bg-silver total">
          <div className="pa3">
            <Button style={{ marginTop: -6 }} floated="right" icon="close" size="mini"
                    onClick={app.sidebar.close.dispatch}/>
            {translate( "cart.cart" )}
          </div>
        </div>
      
        <div className={"pa3"}>
          <Button primary size="small" onClick={app.sidebar.close.dispatch} fluid as={Link} to={"/checkout/"}>{translate( "shop.navigate_to_checkout" )}</Button>
        </div>

        {/* PRODUCT LIST */}
        <div className="pr3 cart-scroll-container">
          <div className="relative">
            {products || null}
            {/*test.length > 0 && test.map((product) => (
              <div key={product.map_id}>{product.map_id}</div>
            ))*/}
          </div>
        </div>
        <div className="fixed bottom-0 left-0 right-0 z-9 bg-white pb3">
          {shop.cart.sum < shop.config.MIN_ORDER_VALUE &&
          <div className="total red">
            <div className="ph3">
              <Icon name="info"/> {translate( "min_order_value" )}
              <span className="pull-right">
              <Price>{shop.config.MIN_ORDER_VALUE}</Price>
            </span>
            </div>
          </div>
          }

          {/*TO CART*/}
          <div className="total bg-silver">
            <div className="ph3">
              {translate( "cart.subtotal" )}
              <span className="pull-right">
              <Price>{shop.cart.sum}</Price>
            </span>
            </div>
          </div>
          <Link to="/checkout/" onClick={app.sidebar.close.dispatch}>
            <div className="ph3 pt3">
              <Button primary fluid>{translate( "shop.navigate_to_checkout" )}</Button>
            </div>
          </Link>
          {shop.config.checkout.requestOffer &&
          <div className="ph3 pt3">
            <Link to="/checkout/request/" onClick={app.sidebar.close.dispatch}>
              <Button primary basic fluid>{translate( "Anfragen" )}</Button>
            </Link>
          </div>
          }
        </div>


      </div>
    )
  }
}

const productEntries = ( { remove } ) => shop.cart.map( ( product, key ) => {
  const cartDescription = product.cartDescription
  return (
    <div key={key}
         className="cart-product relative ">
      {/*<div className="product-thumbnail">*/}
      {/*<Link to={`/product/${product.map_id}`}>*/}
      {/*<img src={product.img_src_small}*/}
      {/*style={{*/}
      {/*maxWidth:     "40px",*/}
      {/*maxHeight: "26px"*/}
      {/*}}*/}
      {/*alt=""/>*/}
      {/*</Link>*/}
      {/*</div>*/}
      <div className="product-description pb3">
        <div className="text-small">
          <Link onClick={app.sidebar.close.dispatch} to={`/product/${product.map_id}`}>
            <div>
              <div className="fr"><Price>{product.price * product.unit_multi * product.count}</Price></div>
              <span className="b  black-70">{(cartDescription) ? cartDescription : ""}</span>
            </div>
          </Link>

          <div
            className="black-50">{`${product.count * product.unit_multi} ${translate("Stk.")} (${product.count} x ${product.unit_multi})`}</div>

          {remove ?
           <div className={"absolute bottom-0 right-0 pb2"}>
             <Button
               basic size="tiny" icon="close" onClick={() => remove( product )}
               role="button" title={translate("remove")}/>
           </div>  : null}
        </div>
      </div>
    </div>
  )
} )

const getProducts = () => shop.cart.map( ( product ) => product)


// WEBPACK FOOTER //
// ./src/components/Cart/CartMini.js